import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';

import { BaseResponse } from '../models/rest/baseResponse';
import { IAppConfigurationBase } from './app-configuration.service';

export interface ICustomerConfig {
  VideoRecordingSaving: boolean;
  VoicePlatformEnabled: boolean;
  AudioRecordsEnabled: boolean;
  AudioRecordsProvider: string;
  VoiceBotEnabled: boolean;
  EVChargersEnabled: boolean;
  PowerAutomateEnabled: boolean;
  MitteEnabled: boolean;
  ParkingBaseEnabled: boolean;
  ParkchirpEnabled: boolean;
  InexLPREnabled: boolean;
  SmsEnabled: boolean;
  StatusPageEnabled: boolean;
  AxxonEnabled: boolean;
  OcraEnabled: boolean;
  PowerBIEnabled: boolean;
  WebRtcEnabled: boolean;
  AcrobitsEnabled: boolean;
  LocationReviewEnabled: boolean;
}

interface IGetCustomerConfigResponse extends BaseResponse {
  Data: ICustomerConfig;
}

@Injectable({ providedIn: 'root' })
export class CustomerConfigService {
  private _config: ICustomerConfig;
  private _path: string;
  private _changed = new Subject<ICustomerConfig>();

  public readonly changed$ = this._changed.asObservable();

  public get config(): ICustomerConfig {
    return this._config;
  }
  constructor(private _httpClient: HttpClient) {}

  loadCustomerConfig(appConfig: IAppConfigurationBase): Promise<IGetCustomerConfigResponse> {
    this._path = `${appConfig.paths.baseUrl}/api/CustomerConfig`;
    return this.load().toPromise();
  }

  refresh(): Observable<ICustomerConfig> {
    return this.load().pipe(map(() => this._config));
  }

  private load(): Observable<IGetCustomerConfigResponse> {
    return this._httpClient.get<IGetCustomerConfigResponse>(this._path).pipe(
      tap(
        (response) => {
          this._config = Object.assign(this._config || {}, response.Data);
          this._changed.next(this._config);
        },
        (error) => {
          console.log('Failed to load Customer configuration', error);
        },
      ),
    );
  }
}
